
import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Instagram, Gift } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#3E2723] text-white py-12" aria-label="Site Footer">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {/* Column 1: Logo and Description */}
          <div>
            <Link to="/" aria-label="Return to homepage" className="inline-block">
              <img
                src="/lovable-uploads/f3fbbbeb-a003-46d1-8a89-de518039703b.png"
                alt="Cats About Town Tours Logo"
                className="h-28 mb-4 mx-auto md:mx-0 w-auto object-contain"
                width="220"
                height="112"
                loading="lazy"
              />
            </Link>
            <p className="text-sm text-gray-300 mt-2 mb-4 text-center md:text-left max-w-xs md:max-w-none">
              Explore the hidden feline history of New York City with our unique walking tours, led by expert guides who bring the stories of historic cats to life.
            </p>
            <div className="flex justify-center md:justify-start space-x-4 mt-6">
              <a 
                href="mailto:catsabouttowntour@gmail.com" 
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors"
                aria-label="Email us"
              >
                <Mail size={18} aria-hidden="true" />
              </a>
              <a 
                href="https://www.instagram.com/catsabouttowntours/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-colors"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={18} aria-hidden="true" />
              </a>
            </div>
          </div>
          
          {/* Column 2: Quick Links */}
          <div>
            <h2 className="text-xl font-semibold mb-4 text-center md:text-left">Quick Links</h2>
            <nav aria-label="Footer Navigation - Quick Links">
              <ul className="space-y-2 text-center md:text-left">
                <li>
                  <Link to="/about" className="text-gray-300 hover:text-white transition-colors hover:underline">About Us</Link>
                </li>
                <li>
                  <Link to="/tours" className="text-gray-300 hover:text-white transition-colors hover:underline">Our Tours</Link>
                </li>
                <li>
                  <Link to="/blog" className="text-gray-300 hover:text-white transition-colors hover:underline">Blog</Link>
                </li>
                <li>
                  <Link to="/gallery" className="text-gray-300 hover:text-white transition-colors hover:underline">Gallery</Link>
                </li>
                <li>
                  <Link to="/petition-jerry-fox" className="text-gray-300 hover:text-white transition-colors hover:underline">Jerry Fox Petition</Link>
                </li>
                <li>
                  <Link to="/press-kit" className="text-gray-300 hover:text-white transition-colors hover:underline">Press Kit</Link>
                </li>
                <li>
                  <Link to="/booking" className="text-gray-300 hover:text-white transition-colors hover:underline">Book a Tour</Link>
                </li>
                <li>
                  <a 
                    href="https://fareharbor.com/embeds/book/catsabouttown/items/562633/calendar/?full-items=yes&flow=1219724" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-white transition-colors hover:underline flex items-center justify-center md:justify-start"
                  >
                    <Gift className="mr-1 h-4 w-4" />
                    Gift Cards
                  </a>
                </li>
                <li>
                  <Link to="/sitemap" className="text-gray-300 hover:text-white transition-colors hover:underline">Sitemap</Link>
                </li>
              </ul>
            </nav>
          </div>
          
          {/* Column 3: Contact Information */}
          <div>
            <h2 className="text-xl font-semibold mb-4 text-center md:text-left">Contact Us</h2>
            <div className="space-y-3 text-center md:text-left">
              <p className="text-gray-300">Have questions or want to arrange a private tour?</p>
              <p>
                <a 
                  href="mailto:catsabouttowntour@gmail.com" 
                  className="text-[#D4AF37] hover:text-[#E7C878] transition-colors hover:underline"
                >
                  catsabouttowntour@gmail.com
                </a>
              </p>
              <div className="pt-4">
                <Link 
                  to="/booking" 
                  className="inline-block bg-[#C46829] hover:bg-[#B35718] text-white py-2 px-6 rounded-md transition-all hover:-translate-y-0.5 hover:shadow-md"
                  aria-label="Book a tour"
                >
                  Book a Tour
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-[#7D5E57] mt-8 pt-8 text-center md:flex md:flex-wrap md:justify-between">
          <p className="text-gray-400 text-sm mb-2 md:mb-0">
            &copy; {currentYear} Cats About Town Tours. All Rights Reserved.
          </p>
          <div className="flex justify-center md:justify-end space-x-4 text-sm text-gray-400">
            <Link to="/sitemap" className="hover:text-white transition-colors">Sitemap</Link>
            <span aria-hidden="true" className="select-none">|</span>
            <Link to="/press-kit" className="hover:text-white transition-colors">Press Kit</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
